import type {
  RegularSkinGetter,
  RegularSkinSchema,
  SOAPSkinSchema,
  SOAPSkinGetter,
} from '../skins/skins.types';
import {
  getCurrentEditorMode,
  getSectionLikeSelectionType,
  pickSkinFromSchema,
} from '../skins/skins.utils';

const sectionSchemaQuickEditBO: RegularSkinSchema = {
  desktop: {
    hovered: 'lightLarge',
    selected: 'lightLarge',
  },
  desktopZoomOut: {
    hovered: 'lightLarge',
    selected: 'lightLarge',
  },
};

const siteSegmentSchemaQuickEditBO: SOAPSkinSchema = {
  desktop: {
    hovered: 'lightLarge-soap',
    selected: 'lightLarge-soap',
  },
  desktopZoomOut: {
    hovered: 'lightLarge-soap',
    selected: 'lightLarge-soap',
  },
};

export const getSectionStageActionsSkin: RegularSkinGetter = (
  editorAPI,
  compRef,
  selectionData,
) => {
  const mode = getCurrentEditorMode(editorAPI);
  const selectionType = getSectionLikeSelectionType(
    editorAPI,
    compRef,
    selectionData,
  );

  return pickSkinFromSchema(sectionSchemaQuickEditBO, mode, selectionType);
};

export const getSiteSegmentStageActionsSkin: SOAPSkinGetter = (
  editorAPI,
  compRef,
  selectionData,
) => {
  const mode = getCurrentEditorMode(editorAPI);
  const selectionType = getSectionLikeSelectionType(
    editorAPI,
    compRef,
    selectionData,
  );

  return pickSkinFromSchema(siteSegmentSchemaQuickEditBO, mode, selectionType);
};
